<template>
  <vue-html2pdf
    :show-layout="false"
    :float-layout="true"
    :enable-download="true"
    :preview-modal="false"
    filename="FicheEvaluation"
    :paginate-elements-by-height="2000"
    pdf-content-width="800px"
    :manual-pagination="false"
    ref="html2Pdf"
  >
    <section slot="pdf-content" ref="pdfContent">
      <fiche-evaluation-deno
        :deno="deno"
        :evaluations="evaluations"
      ></fiche-evaluation-deno>
    </section>
  </vue-html2pdf>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf-fixed";
import html2pdf from "html2pdf.js";
import FicheEvaluationDeno from "@/components/FicheEvaluationDeno";
export default {
  name: "AppPdfGenerator",
  components: {
    VueHtml2pdf,
    FicheEvaluationDeno,
  },
  props: {
    filename: {
      type: String,
      default: "document",
    },
    deno: {
      type: Object,
      required: true,
    },
    evaluations: {
      type: Array,
      required: true,
    },
  },
  methods: {
    async downloadPdf() {
      // Set Element and Html2pdf.js Options
      const pdfContent = this.$refs.pdfContent;
      let options = this.setOptions();
      this.$emit("beforeDownload", { html2pdf, options, pdfContent });
      const html2PdfSetup = html2pdf().set(options).from(pdfContent);

      await html2PdfSetup.save().output("bloburl");
    },
    setOptions() {
      if (
        this.htmlToPdfOptions !== undefined &&
        this.htmlToPdfOptions !== null
      ) {
        return this.htmlToPdfOptions;
      }
      return {
        margin: [3, 3, 0.2, 3],
        filename: `${this.filename}.pdf`,
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        enableLinks: false,
        html2canvas: {
          scale: 2,
          useCORS: true,
        },
        jsPDF: {
          unit: "mm",
          format: "A4",
          orientation: "portrait",
        },
      };
    },
  },
};
</script>

<style></style>
